<table mat-table [dataSource]="dataSource" matSort matSortActive="INDEX_ZI">
  <ng-container matColumnDef="DESC">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'change.prismaImport.docItemNumberDesc' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">{{ element.PMDESC }}</td>
  </ng-container>

  <ng-container matColumnDef="SNR">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'change.pmPositionList.pmSNR' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">{{ element.BMNR }}</td>
  </ng-container>

  <ng-container matColumnDef="PMDESCRIPTION">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'change.pmPositionList.pmDesc' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">{{ element.PMDESC }}</td>
  </ng-container>

  <ng-container matColumnDef="PLANNING">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'change.pmPositionList.planning' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">{{ element.PM_PLANNER_NAME }}</td>
  </ng-container>

  <ng-container matColumnDef="METROLOGIST">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'change.pmPositionList.metrologist' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.PM_METROLOGIST_NAME }}
    </td>
  </ng-container>

  <ng-container matColumnDef="PROJECT">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'change.pmPositionList.leadProject' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">{{ element.PROJECTNAME }}</td>
  </ng-container>

  <ng-container matColumnDef="PMGROUP">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'change.pmPosition.pmGroup' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">{{ element.PMGROUP }}</td>
  </ng-container>

  <ng-container matColumnDef="PRICE">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'change.pmPositionList.price' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">{{ element.BETRAG | currency }}</td>
  </ng-container>

  <ng-container matColumnDef="APPOINTMENT">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'change.pmPositionList.date' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">{{ element.TERMIN | date }}</td>
  </ng-container>

  <ng-container matColumnDef="DELIVERYDATE">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'change.pmPositionList.deliveryDate' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">{{ element.PBO_POS_LIEFERDATUM | date }}</td>
  </ng-container>

  <ng-container matColumnDef="INSPECTION_REPORT">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'change.pmPositionList.testReport' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">
      <div *ngIf="element.POS_HAS_INSPECTION_REPORT" style="color: #2E7D32">
        <mat-icon>check_circle</mat-icon>
        PRÜFBERICHT
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="BUTTONS">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'change.pmPositionList.actions' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">
      <button
        mat-icon-button
        color="primary"
        matTooltip="{{ 'orders.positions.pm.documents' | translate }}"
        routerLink="/orders/{{ ar.snapshot.params.id }}/{{
          element.LINK_ID
        }}/pmdocuments">
        <mat-icon>article</mat-icon>
      </button>
      <span>|</span>
      <button
        mat-button
        color="primary"
        (click)="downloadReport(element.OBJECT_ID, 'PM-PB')">
        {{ 'change.pmPositionList.testReport' | translate }}
      </button>
      <button
        mat-button
        color="primary"
        (click)="downloadReport(element.OBJECT_ID, 'ET-TS')">
        ET
      </button>
      <button
        mat-button
        color="primary"
        (click)="downloadReport(element.OBJECT_ID, 'ZB-TS')">
        ZB
      </button>
      <span>|</span>
      <button
        mat-button
        color="primary"
        matTooltip="Prüfbericht hochladen"
        (click)="uploadInspectionReport(element.OBJECT_ID)">
        <mat-icon>file_upload</mat-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
